import * as Popper from '@popperjs/core'
import * as bootstrap from 'bootstrap'
import axios from 'axios'
import lazysizes from 'lazysizes'
import iziToast from 'izitoast'

try {
    window.axios = axios
    window.lazysizes = lazysizes
    window.iziToast = iziToast
    window.Popper = Popper
    window.bootstrap = bootstrap
} catch (e) {}

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
  console.error(
    'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token',
  )
}

// window.axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const statusCode = error.response ? error.response.status : null
//     if (statusCode === 419) {
//       window.location = '/login'
//     }
//     throw error
//   },
// )
